import { Locale } from 'models'

export const timestampFormat = 'YYMMDDHHmmssSS'
export const datetimestampFormat = 'YYMMMMDoHHmmssSS'
export const storeDateFormat = 'YYMMDD'
export const displayDateFormat = 'MM/DD/YY'
export const displayHourFormat = 'LT'
export const displayFullDateMonthFormat = 'MMMM Do'
export const defaultLocale: Locale = {
  locale: 'en-US',
  currency: 'USD',
}
export const defaultTZ = 'US/Pacific'
export const defaultDelayTime = 20
export const defaultDeliveryTime = 20
